import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @mui/material components
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
// core components
import Navbar from "../../components/Navbars/Navbar";
import Footer from "../Footer/Footer.jsx";
import Sidebar from "../../components/Sidebar/Sidebar";
import {
  drawerWidth,
} from "../../components/assets/jss/material-dashboard-react";
///import routes from "routes.js";

import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import bgImage from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/reactlogo.png";

let ps;


const SwitchRoutes = ({routes}) =>(
  <Routes>
    {routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        const fullPath = prop.path.startsWith("/") ? prop.path.slice(1) : prop.path;
        const Component = prop.component;
        return (
          <Route key={key} path={fullPath} element={<Component />} />
        );
      }
      return null;
    })}
    <Route path="/admin" element={<Navigate to="/admin/home" replace />} />

     {/* Fallback 404 */}
    <Route path="*" element={<div>Not Found</div>} />
  </Routes>
);

export default function Admin(props) {
 

  const theme = useTheme()
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = useRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  
 const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
 const getRoute = () => window.location.pathname !== "/admin/maps";

 
 
  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) {
      const ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
      return () => ps.destroy();
    }
  }, []);

  useEffect(() => {
    const resizeFunction = () => {
      if (window.innerWidth >= 960) {
        setMobileOpen(false);
      }
    };

    window.addEventListener("resize", resizeFunction);
    return () => window.removeEventListener("resize", resizeFunction);
  }, []);



  return (
    <Box sx={{ height: "100vh", display: "flex", width: '100vw', overflowX: 'hidden' }}>
      
      <Sidebar
        routes={props.routes}
        logoText={"CT-ONLINQ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        
      />
          <Box
                ref={mainPanel}
                sx={{
                  flexGrow: 1,
                  width: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` },
                  overflowY: "auto",
                  height: '100vh',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)",
                }}
              >
              <Navbar
                routes={props.routes}
                handleDrawerToggle={handleDrawerToggle}
                type="admin"
                lay="/admin"
                
              />
              
                <Box sx={{ flex: 1, px: 3, pt: 2 }}>
                 
                  <SwitchRoutes routes={props.routes} />
                </Box>
              
              {getRoute() ? <Footer type= "admin" /> : null}
              
              
          </Box>
    </Box>
  );
}
